export function width(el) {
  let width = el.clientWidth
  const computedStyle = getComputedStyle(el);
  width -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
  return width
}
